import React from 'react';
// Helper to get subdirectory from window variable (set in UIRouter.tsx).
const getSubdirectory = () => {
    if (typeof window !== 'undefined' && window.__TB_SUBDIRECTORY__) {
        const subdirectory = window.__TB_SUBDIRECTORY__;
        // Return without trailing slash.
        return subdirectory && subdirectory.endsWith('/') ? subdirectory.slice(0, -1) : subdirectory || '';
    }
    return '';
};
export const Svg = ({ path, label, root }) => {
    const subdirectory = getSubdirectory();
    const defaultRoot = '/images/sprites.svg';
    // If root is provided and absolute URL, use it as-is; otherwise prepend subdirectory.
    let rootPath;
    if (root) {
        if (root.startsWith('http://') || root.startsWith('https://')) {
            rootPath = root;
        }
        else {
            rootPath = `${subdirectory}${root.startsWith('/') ? root : `/${root}`}`;
        }
    }
    else {
        rootPath = `${subdirectory}${defaultRoot}`;
    }
    return (React.createElement("svg", { "aria-label": label },
        React.createElement("use", { href: `${rootPath}#${path}` })));
};
//# sourceMappingURL=Svg.js.map